
/**
 * Базовый дата-компонент для получения списка сущностей из api и для навигации по нему
 */

import DataEntityListMixin from '~/mixins/dataEntityListMixin'

export default {
  mixins: [DataEntityListMixin],
}
